import { render } from "./OurTeam.vue?vue&type=template&id=1e839244&scoped=true"
import script from "./OurTeam.vue?vue&type=script&lang=js"
export * from "./OurTeam.vue?vue&type=script&lang=js"

import "./OurTeam.vue?vue&type=style&index=0&id=1e839244&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e839244"]])

export default __exports__